import React from "react";

/**
 * Renders a loading a loading indicator
 * @param {boolean} loading loading prop
 * @param {boolean} bar prop to determine the kind of loading icon to display; circler (default) or bar
 */
const LoadingSpinner = ({ loading, bar }) =>
	loading && (
		<div>
			{bar && bar === true ? (
				<div className="text-left mb-24">
					<img
						src="/main/img/index.messenger-typing-preloader.svg"
						alt="loading"
					/>
				</div>
			) : (
				<div className="text-center mt-10 mb-10">
					<img
						src="/main/img/index.rotating-balls-spinner.svg"
						alt="loading"
					/>
				</div>
			)}
		</div>
	);

export default LoadingSpinner;
